import { IngestSubfolder } from '../../../../domain/src/lib/ingest/ingest-project.model';

export interface FolderTreeNode {
  label: string;
  path: string;
  children: FolderTreeNode[];
}

/** Construye un árbol jerárquico a partir de rutas planas de subcarpetas. */
export function buildFolderTreeFromSubfolders(subfolders: IngestSubfolder[]): FolderTreeNode {
  const root: FolderTreeNode = { label: 'Raíz', path: '', children: [] };
  const byPath = new Map<string, FolderTreeNode>();
  byPath.set('', root);

  const sorted = [...subfolders].sort((a, b) => a.path.localeCompare(b.path));
  for (const s of sorted) {
    if (!s.path) continue;
    const parts = s.path.split('/').filter(Boolean);
    let acc = '';
    let parent = root;
    for (let i = 0; i < parts.length; i++) {
      const segment = parts[i];
      acc = acc ? `${acc}/${segment}` : segment;
      let node = byPath.get(acc);
      if (!node) {
        const isLeaf = i === parts.length - 1;
        const label = isLeaf ? s.display_name || segment : segment;
        node = { label, path: acc, children: [] };
        byPath.set(acc, node);
        parent.children.push(node);
      }
      parent = node;
    }
  }

  const sortRecursive = (n: FolderTreeNode): void => {
    n.children.sort((a, b) => a.label.localeCompare(b.label, 'es'));
    n.children.forEach(sortRecursive);
  };
  sortRecursive(root);
  return root;
}
